import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SupportChat from "@/components/SupportChat";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

export default function Layout({ children }) {
    const { user } = useAuth();

    // Presence heartbeat while logged in
    useEffect(() => {
        if (!user) return;
        const ping = () => { api.post("/chat/heartbeat", {}).catch(() => {}); };
        ping();
        const iv = setInterval(ping, 30000);
        const onVisible = () => { if (!document.hidden) ping(); };
        document.addEventListener("visibilitychange", onVisible);
        return () => {
            clearInterval(iv);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, [user]);

    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <SupportChat />
        </div>
    );
}
